import React, {useState, useEffect} from 'react'
import axios from 'axios'
import './SnippetEditor.scss'
import ErrorMessage from '../misc/ErrorMessage';
import domain from '../../util/domain'

function SnippetEditor({getSnippets, setFormOpen, editData}) {
    const [editorTitle, setEditorTitle] = useState("");
    const [editorDescription, setEditorDescription] = useState("");
    const [editorCode, setEditorCode] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);

    
    useEffect(()=> {
        if (editData) {
            setEditorTitle(editData.title ? editData.title : "Title")
            setEditorDescription(editData.description ? editData.description : "Description")
            setEditorCode(editData.code ? editData.code : "Code")
        }
    }, [editData])

    async function saveSnippet(e) {
        e.preventDefault()
        const snippetData = {
            title: editorTitle ? editorTitle : undefined,
            description: editorDescription ? editorDescription : undefined,
            code: editorCode ? editorCode : undefined
        }
        try {
        if(!editData) await axios.post(`${domain}/snippet/`, snippetData)
        else await axios.put(`${domain}/snippet/${editData._id}`, snippetData)
        } catch (err) {
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
            return
        }
        getSnippets();
        closeEditor();
    }

    function closeEditor() {
        setFormOpen(false);
        setEditorTitle("");
        setEditorDescription("");
        setEditorCode("");
    }
    
    return (
        <div className='snippet-editor'>
                <form className="form" onSubmit={saveSnippet}>
                {errorMessage && <ErrorMessage message={errorMessage} clear={() => setErrorMessage(null)}/>}
                    <label htmlFor="editor-title">Title</label>
                    <input id="editor-title" type="text" value={editorTitle} onChange={(e) => {setEditorTitle(e.target.value)}} required={true}/>
                    <label htmlFor="editor-description">Description</label>
                    <input id="editor-description" type="text" value={editorDescription} onChange={(e) => setEditorDescription(e.target.value)} required={true}/>
                    <label htmlFor="editor-code">Code</label>
                    <textarea id="editor-code" value={editorCode} onChange={(e) => setEditorCode(e.target.value)} required={true}/>
                    <button className="btn-save-snippet" type="submit">Save snippet</button>
                    <button className="btn-close-editor" type="button" onClick={closeEditor}>Close</button>
                </form>
            </div>
    )
}

export default SnippetEditor
